export default __webpack_public_path__ + "static/media/down.500fdee9.svg";